"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TOOLTIPS = {
    CUSTOMERS_PORTAL_ADMINS_LIST: {
        FIRST_NAME_FILTER: 'Filter by customer\'s portal admin first name.',
        LAST_NAME_FILTER: 'Filter by customer\'s portal admin last name.',
    },
    FAULT: {
        CONNECTED_FILTER: 'Responsive vehicles with no unresolved \'Service Now\' or \'Service Soon\' fault.',
        EVENT_ID: 'Event ID is unique for each fault event.',
        FAULT: 'Filter by \'Suspect Parameter Number\' (SPN) / \'Failure Mode Identifier\' (FMI).',
        FLAG: 'Toggle on/off flags. Your selections don\'t display to other users.',
        FMI: 'Filter by Failure Mode Identifier (FMI).',
        GEOFENCE: 'Did fault occur within a service facility \'geofence\'? (Triggered by technician?)',
        NO_STATUS_FILTER: 'Vehicles which haven\'t contacted Detroit Connect.',
        RINGBUFFER: 'Is 75 seconds of sensor data available to aid fault diagnosis?',
        EMAIL_NOTIFICATION_SENT: 'Was a notification sent for this fault event?',
        SA: 'Filter by Source Address (SA). See Help&Support for a list of Source Addresses.',
        SERVICE_NOW_FILTER: 'Vehicles with one or more unresolved \'Service Now\' fault.',
        SERVICE_PM_FILTER: 'Vehicles with one or more unresolved \'Service Preventive Maintenance\' fault.',
        SERVICE_SOON_FILTER: 'Vehicles with one or more unresolved \'Service Soon\' fault.',
        SPN: 'Filter by Suspect Parameter Number (SPN).',
        STATUS: 'Fault severity: (red) Service Now, (amber) Service Soon, (blue) Service Preventative Maintenance or (grey) Service Info.',
        TIME: 'When did the fault occur on the vehicle?',
        TITLE: 'Filter by any part of fault title: Suspect Parameter / Failure Mode.',
    },
    VEHICLE_LIST: {
        CONNECTED_FILTER: 'Responsive vehicles with no unresolved \'Service Now\', \'Service Soon\' or \'Service PM\' faults within the past 7 days.',
        NO_STATUS_FILTER: 'Vehicles which have not transmitted any information to Detroit Connect within the past 7 days.',
        SERIAL_FILTER: 'Filter by vehicle serial number (i.e. final six digits of 17 digit VIN).',
        SERVICE_NOW_FILTER: 'Vehicles with one or more unresolved \'Service Now\' faults within the past 7 days.',
        SERVICE_PM_FILTER: 'Vehicles with one or more unresolved \'Service PM\' but no \'Service Now\' or \'Service Soon\' unresolved faults within the past 7 days.',
        SERVICE_SOON_FILTER: 'Vehicles with one or more unresolved \'Service Soon\' faults but no \'Service Now\' unresolved faults within the past 7 days.',
        UNIT_ID_FILTER: 'Filter by fleet-assigned Unit ID number.',
        PRE_WIRE_FILTER: 'Pre Wire',
    },
};
exports.default = TOOLTIPS;
